// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  align-items: center;
  display: flex;
  min-height: 100vh;
  justify-content: center;
  width: 100%; }

.inner-container {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem; }

.side-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-self: stretch;
  margin: 0.5rem 0; }
  .side-wrapper .teams-summary {
    flex: 1 1 auto; }
`, "",{"version":3,"sources":["webpack://./src/components/Board.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,WAAW,EAAA;;AAGb;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB,EAAA;EALlB;IAQI,cAAc,EAAA","sourcesContent":[".container {\n  align-items: center;\n  display: flex;\n  min-height: 100vh;\n  justify-content: center;\n  width: 100%;\n}\n\n.inner-container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 1rem;\n}\n\n.side-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-self: stretch;\n  margin: 0.5rem 0;\n\n  .teams-summary {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
